// AUTO-GENERATED by scripts/generate-build-version.mjs. Do not edit.
// Cambia automáticamente cuando cambian los archivos de traducción.
export const BUILD_VERSION = '9f517883c396';
export const APP_VERSION = '2.0.5';
